import { render, staticRenderFns } from "./UserReview.vue?vue&type=template&id=43004894&lang=pug&"
import script from "./UserReview.vue?vue&type=script&lang=js&"
export * from "./UserReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports